// import Cookies from "universal-cookie";

// const cookies = new Cookies();

export const fetchStripeCustomerPortalInfo = async (data) => {

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/stripe/create/customer_portal`,
   // 'http://localhost:3000/api/stripe/create/customer_portal',
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
     // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );

  //   return response;
  if (response.status === 200) {
    const data = response.json();
    return data;
  }
};
